import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import Loading from "components/Loading";
import { Button as MUIButton } from "@mui/material";

const Button: FC<Props> = ({
  className = "",
  text,
  element,
  onClick,
  handleError = () => {},
  disabled = false,
  loading = false,
  color = "primary",
}) => {
  return (
    <MUIButton
      style={{ textTransform: "none", boxShadow: "none", borderRadius: "8px" }}
      className={`${className} ${styles.bn}`}
      onClick={(e) => {
        if (loading) return;
        if (disabled) {
          handleError();
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      variant="contained"
      color={color}
      disabled={disabled}
    >
      {loading ? <Loading withoutText /> : <>{element ? element : text}</>}
    </MUIButton>
  );
};

export default Button;
